import { useContext, useState } from 'react';
import { DatePicker, Radio } from 'antd';
import {
  SendOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import { KickOffContext } from '../ModalKickOff';
import dayjs from 'dayjs';

const P60_OPTIONS = {
  IMMEDIATELY: 'IMMEDIATELY',
  SCHEDULE_LATER: 'SCHEDULE_LATER',
} as const;

const P60Step = () => {
  const [selectedOption, setSelectedOption] = useState<string>(P60_OPTIONS.IMMEDIATELY);
  const { p60issueDate, setP60issueDate } = useContext(KickOffContext);

  const minDate = dayjs().month(3).date(6); // April 6

  const handleOptionChange = (option: string) => {
    setSelectedOption(option as keyof typeof P60_OPTIONS);
    if (option === P60_OPTIONS.IMMEDIATELY) {
      setP60issueDate(null);
    }
  };

  const cardStyle = (isActive: boolean): React.CSSProperties => ({
    padding: 24,
    border: `1px solid ${isActive ? '#00795B' : '#d9d9d9'}`,
    borderRadius: 10,
    cursor: 'pointer',
    marginTop: 12,
    display: 'flex',
    gap: 15,
    opacity: isActive ? 1 : 0.5,
  });

  return (
    <>
      <div style={{ color: '#00795B', fontSize: '1.3rem', marginBottom: 8 }}>
        Customize your P60 issue date.
      </div>
      <div
        style={cardStyle(selectedOption === P60_OPTIONS.IMMEDIATELY)}
        onClick={() => handleOptionChange(P60_OPTIONS.IMMEDIATELY)}
      >
        <Radio checked={selectedOption === P60_OPTIONS.IMMEDIATELY} />
        <div>
          <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
            <SendOutlined
              style={{
                color:
                  selectedOption === P60_OPTIONS.IMMEDIATELY
                    ? '#00795B'
                    : '#2F2B3D',
              }}
            />
            Send as soon as possible
          </div>
          <div style={{ color: '#2F2B3DB2', fontSize: '0.85rem' }}>
            We will send the P60s as soon as they become available in our
            system.
          </div>
        </div>
      </div>
      <div
        style={cardStyle(selectedOption === P60_OPTIONS.SCHEDULE_LATER)}
        onClick={() => handleOptionChange(P60_OPTIONS.SCHEDULE_LATER)}
      >
        <Radio checked={selectedOption === P60_OPTIONS.SCHEDULE_LATER} />
        <div>
          <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
            <ClockCircleOutlined
              style={{
                color:
                  selectedOption === P60_OPTIONS.SCHEDULE_LATER
                    ? '#00795B'
                    : '#2F2B3D',
              }}
            />
            Schedule for later
          </div>
          <div style={{ color: '#2F2B3DB2', fontSize: '0.85rem' }}>
            Choose a date, and the system will automatically send the P60s on
            the selected day.
          </div>
          {selectedOption === P60_OPTIONS.SCHEDULE_LATER && (
            <div style={{ width: 200, marginTop: 8 }}>
              <DatePicker
                placeholder="Choose a date"
                format="DD/MM/YYYY"
                value={p60issueDate ? dayjs(p60issueDate) : null}
                defaultPickerValue={minDate}
                onChange={(date) =>
                  setP60issueDate(date ? date.toISOString() : null)
                }
                disabledDate={(current) =>
                  current && current.isBefore(minDate, 'day')
                }
                style={{ width: '100%' }}
                status={
                  selectedOption === P60_OPTIONS.SCHEDULE_LATER && !p60issueDate
                    ? 'error'
                    : undefined
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default P60Step;
